const genRoute = [
  {
    path: "/:appId/gen-studio/dashboard",
    name: "gen-studio.gen-studio.dashboard",
    component: () =>
      import("@/views/gen-studio/components/assistant/Dashboard.vue"),
    meta: { title: "Dashboard Analytics" },
  },
  {
    path: "/:appId/gen-studio",
    name: "gen-studio.gen-studio",
    component: () => import("@/views/gen-studio/pages/ListAssistant.vue"),
    meta: { title: "Gen AI Studio" },
    redirect: {
      name: "gen-studio.gen-studio.assistant",
    },
  },
  {
    path: "/:appId/gen-studio/:assistantId",
    name: "gen-studio-detail",
    component: () => import("@/views/gen-studio/pages/Assistant.vue"),
    meta: { title: "Gen AI Studio" },
  },
  {
    path: "/:appId/gen-studio/assistant/create",
    name: "gen-studio.gen-studio.create",
    component: () =>
      import("@/views/gen-studio/components/assistant/Create.vue"),
    meta: { title: "Create your Bot Assistant" },
  },
  {
    path: "/:appId/gen-studio/assistant",
    name: "gen-studio.gen-studio.assistant",
    component: () => import("@/views/gen-studio/pages/ListAssistant.vue"),
    meta: { title: "Assistant" },
  },
  {
    path: "/:appId/agent-ai",
    name: "gen-studio.agent-ai",
    component: () => import("@/views/gen-studio/pages/agent-ai/List.vue"),
    meta: { title: "Agent AI" },
    redirect: {
      name: "gen-studio.agent-ai",
    },
  },
  {
    path: "/:appId/gen-studio/agent-ai",
    name: "gen-studio.agent-ai.dashboard",
    component: () => import("@/views/gen-studio/pages/agent-ai/Dashboard.vue"),
    meta: { title: "Dashboard" },
  },
  {
    path: "/:appId/gen-studio/agent-ai/list",
    name: "gen-studio.agent-ai.agent-ai",
    component: () => import("@/views/gen-studio/pages/agent-ai/List.vue"),
    meta: { title: "AI Agent" },
  },
  {
    path: "/:appId/gen-studio/agent-ai/log",
    name: "gen-studio.agent-ai.log",
    component: () => import("@/views/gen-studio/pages/agent-ai/Log.vue"),
    meta: { title: "Log" },
  },
  {
    path: "/:appId/gen-studio/agent-ai/:assistantId",
    name: "gen-studio.agent-ai.agent-ai.detail",
    component: () => import("@/views/gen-studio/pages/agent-ai/Detail.vue"),
    meta: { title: "AI Agent Detail" },
  },
  {
    path: "/:appId/gen-studio/knowledge-center",
    name: "gen-studio.gen-studio.knowledge-center",
    component: () => import("@/views/gen-studio/pages/KnowledgeCenter.vue"),
    meta: { title: "Knowledge Center" },
  },
  {
    path: "/:appId/gen-studio/bot-log",
    name: "gen-studio.gen-studio.bot-log",
    component: () => import("@/views/gen-studio/pages/BotLogs.vue"),
    meta: { title: "Bot Log" },
  },
  {
    path: "/:appId/gen-studio/generate-score",
    name: "gen-studio.scoring.generate-score",
    component: () => import("@/views/scoring/pages/GenerateScore.vue"),
    meta: { title: "Generate Score" },
  },
  {
    path: "/:appId/gen-studio/scoring-history",
    name: "gen-studio.scoring.scoring-history",
    component: () => import("@/views/scoring/pages/ScoringHistory.vue"),
    meta: { title: "Scoring History" },
  },
  {
    path: "/:appId/gen-studio/scoring-history",
    name: "gen-studio.scoring",
    component: () => import("@/views/scoring/pages/ScoringHistory.vue"),
    meta: { title: "Scoring History" },
  },
  {
    path: "/:appId/gen-studio/scoring-history/:historyId/detail",
    name: "gen-studio.scoring.scoring-detail",
    component: () => import("@/views/scoring/pages/Scoringdetail.vue"),
    meta: { title: "Scoring Detail" },
  },
];
export default genRoute;
